import { useEffect, useState } from 'react';
import { Navigation, Volume2, VolumeX, Bell, BellOff, PhoneCall } from 'lucide-react';
import ModalShell from '../../components/ui/ModalShell';
import { jeAplikace } from '../../lib/aplikace';
import { useOsobniNavigace, ulozOsobni } from './doprava/osobni';

/**
 * Nastavení navigace pro sebe (2026-10-26) — z ⋯ běžící směny rozvozce.
 * Platí jen pro přihlášeného rozvozce na tomhle telefonu.
 */
export default function NastaveniNavigace({ open, onClose, isDark }) {
    const n = useOsobniNavigace();
    // Smí se aplikace po vytočení vrátit dopředu? (APK úrovně 6+, jinak null)
    const [navrat, setNavrat] = useState(null);
    useEffect(() => {
        if (!jeAplikace()) return;
        const zjisti = () => Promise.resolve(window.__FL_APLIKACE?.telefon?.stav?.())
            .then((s) => setNavrat(typeof s?.navratPoHovoru === 'boolean' ? s.navratPoHovoru : null));
        zjisti();
        // Po návratu z nastavení Androidu znovu.
        window.addEventListener('focus', zjisti);
        document.addEventListener('visibilitychange', zjisti);
        return () => { window.removeEventListener('focus', zjisti); document.removeEventListener('visibilitychange', zjisti); };
    }, []);

    return (
        <ModalShell open={open} onClose={onClose} isDark={isDark} nadpis="Nastavení navigace" ikona={Navigation} barva="#A855F7" sirka={420}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                <Radek
                    Ikona={n.upozorneni ? Bell : BellOff}
                    nazev="Upozornění na trase"
                    popis="Stopky, radary, hlídky a nehody — karta nahoře i hlas."
                    zapnuto={n.upozorneni}
                    onClick={() => ulozOsobni({ upozorneni: !n.upozorneni })}
                />
                <Radek
                    Ikona={n.hlas ? Volume2 : VolumeX}
                    nazev="Hlas"
                    popis={n.upozorneni ? 'Upozornění a rychlost nahlas. Vypnuté = jen karta na displeji.' : 'Upozornění jsou vypnutá, hlásí se jen překročení rychlosti.'}
                    zapnuto={n.hlas}
                    onClick={() => ulozOsobni({ hlas: !n.hlas })}
                />
                {jeAplikace() && (
                    <button
                        type="button"
                        onClick={() => window.__FL_APLIKACE?.telefon?.povolitNavratPoHovoru?.()}
                        style={{
                            display: 'flex', alignItems: 'center', gap: 12, textAlign: 'left', padding: '12px 14px', borderRadius: 14,
                            background: 'rgba(127,127,140,0.10)', border: '1px solid rgba(127,127,140,0.22)', color: 'var(--text-primary)', cursor: 'pointer',
                        }}
                    >
                        <PhoneCall size={22} style={{ color: '#A855F7', flexShrink: 0 }} />
                        <span style={{ minWidth: 0 }}>
                            <span style={{ display: 'block', fontSize: 15, fontWeight: 800 }}>Navigace i při hovoru</span>
                            <span style={{ display: 'block', fontSize: 13, color: navrat ? '#22C55E' : 'var(--text-secondary)', marginTop: 2, fontWeight: navrat ? 700 : 400 }}>
                                {navrat
                                    ? 'Zapnuto — po vytočení se navigace hned vrátí, hovor běží nahoře v liště.'
                                    : 'Po vytočení se navigace hned vrátí a hovor zůstane nahoře v liště. Ťukni a zapni „Zobrazovat přes jiné aplikace“.'}
                            </span>
                        </span>
                    </button>
                )}
            </div>
        </ModalShell>
    );
}

function Radek({ Ikona, nazev, popis, zapnuto, onClick }) {
    return (
        <button
            type="button"
            role="switch"
            aria-checked={zapnuto}
            onClick={onClick}
            style={{
                display: 'flex', alignItems: 'center', gap: 12, textAlign: 'left', padding: '12px 14px', borderRadius: 14, minHeight: 64,
                background: 'rgba(127,127,140,0.10)', border: '1px solid rgba(127,127,140,0.22)', color: 'var(--text-primary)', cursor: 'pointer',
            }}
        >
            <Ikona size={22} style={{ color: zapnuto ? '#A855F7' : 'var(--text-secondary)', flexShrink: 0 }} />
            <span style={{ flex: 1, minWidth: 0 }}>
                <span style={{ display: 'block', fontSize: 15, fontWeight: 800 }}>{nazev}</span>
                <span style={{ display: 'block', fontSize: 13, color: 'var(--text-secondary)', marginTop: 2 }}>{popis}</span>
            </span>
            <span style={{ width: 46, height: 28, borderRadius: 14, position: 'relative', flexShrink: 0, background: zapnuto ? '#A855F7' : 'rgba(127,127,140,0.35)', transition: 'background 0.15s' }}>
                <span style={{ position: 'absolute', top: 3, left: zapnuto ? 21 : 3, width: 22, height: 22, borderRadius: 11, background: '#fff', transition: 'left 0.15s' }} />
            </span>
        </button>
    );
}
